import { useState } from "react";
import { useSelector } from "react-redux";
import { Set } from "../../../../Request";

export const useBug = () => {
  const { user } = useSelector(state => state);
  const [form, setForm] = useState({
    mobile: user ? user.fullname : "",
    fullname: user ? user.mobile : "",
    title: "",
    message: "",
    platform: "site",
  });
  const [loading, setloading] = useState(false);
  const sendBug = async data => {
    setloading(true);
    await Set({
      url: "/report_bug/create",
      data: { ...form, ...data },
    }).then(data => {
      if (data)
        setForm({
          mobile: "",
          fullname: "",
          title: "",
          message: "",
          platform: "site",
        });
      setloading(false);
    });
  };
  return {
    form,
    setForm,
    loading,
    sendBug,
  };
};
